import { useQuery } from '@tanstack/react-query';
import { isUniversalSearchReady, UNIVERSAL_SEARCH_LIMIT_PER_KIND } from '../../lib/universalSearch';
import { searchUniversal } from '../../services/search/universalSearchService';
import { useAuthStore } from '../../store/useAuthStore';
import { useCanAccessFeature } from '../usePermissions';
import { useEffectiveDossierFields } from './useCabinetSettings';

/** `limit` : nombre de résultats par famille (5 dans le champ de l'en-tête, davantage sur la page de résultats). */
export function useUniversalSearch(query: string, limit: number = UNIVERSAL_SEARCH_LIMIT_PER_KIND) {
  const isInitialized = useAuthStore((s) => s.isInitialized);
  const session = useAuthStore((s) => s.session);
  const dossiers = useCanAccessFeature('dossiers_view');
  const contacts = useCanAccessFeature('contacts_view');
  const tickets = useCanAccessFeature('tickets_view');
  const files = useCanAccessFeature('files_view');
  const emails = useCanAccessFeature('dossiers_view');
  const calendar = useCanAccessFeature('calendar_view');
  const tasks = useCanAccessFeature('tasks_view');
  const collaborators = useCanAccessFeature('profile_view');
  const { prescription } = useEffectiveDossierFields();
  const ready = isUniversalSearchReady(query);
  const term = query.trim();

  return useQuery({
    staleTime: 30_000,
    queryKey: ['universal-search', term, limit, dossiers, contacts, tickets, files, emails, calendar, prescription, tasks, collaborators],
    queryFn: () =>
      searchUniversal(term, { dossiers, contacts, tickets, files, emails, calendar, prescription, tasks, collaborators }, limit),
    enabled: ready && isInitialized && !!session,
  });
}
